var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.clicked_row}},[_c('b-card',[_c('webix-ui',{attrs:{"config":_vm.config},model:{value:(_vm.activity_steps),callback:function ($$v) {_vm.activity_steps=$$v},expression:"activity_steps"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }